/**
 * 表格中常用的姓名和遍号信息
 * @author menghao
 */
import React from "react";
import style from "./index.module.scss";
import { Tooltip } from "antd";
import className from "classnames";

interface MultiLineColumnProps {
    name?: React.ReactNode;
    no?: string;
    width?: number;
    extra?: string;
}

export default function MultiLineColumn({
    name,
    no,
    width = 150,
    extra
}: MultiLineColumnProps) {
    return (
        <div className={style.root}>
            <Tooltip title={name} placement={"topLeft"}>
                <span className={style.name} style={{ maxWidth: width }}>
                    {name}
                </span>
            </Tooltip>
            {extra && (
                <Tooltip title={`${no}-${extra}`} placement={"topLeft"}>
                    <span
                        className={className(style.no, style.name)}
                        style={{ maxWidth: width }}>
                        {no}-{extra}
                    </span>
                </Tooltip>
            )}

            {!extra && <span className={style.no}>{no}</span>}
        </div>
    );
}
